import { Component, OnInit, Input } from '@angular/core';
import { FormBaseConfig } from '../../models/form-field.model';
import { FormGroup } from '@angular/forms';
import { FormConfigInstance } from '../../services/form.service';

@Component({
  selector: 'gio-form-grid',
  templateUrl: './form-grid.component.html',
  styleUrls: ['./form-grid.component.scss'],
  host: {
    '[style]': 'params.hostStyle'
  },
})
export class FormGridComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() service: FormConfigInstance;

  params: FormBaseConfig;

  constructor() { }

  ngOnInit(): void {
    this.params = this.service.params;
  }

}
